import createMediaGalleryAssets from './create-media-gallery-assets';
import clientUploadAsset from './client-upload-asset';
import clientUploadAssets from './client-upload-assets';
import uploadAssetsFromExternalSources from './upload-assets-from-external-sources';
import getMediaLibraryAsset from './get-media-library-asset';

export default {
  clientUploadAsset,
  clientUploadAssets,
  uploadAssetsFromExternalSources,
  createMediaGalleryAssets,
  getMediaLibraryAsset,
};
